import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb213f14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cb213f14&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=cb213f14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb213f14",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/layout/index.vue
// module id = null
// module chunks = 